import {AppCommunicator} from "../utils/communicator/AppCommunicator"
import BrowserCommunicator from "../utils/communicator/BrowserCommunicator"

let communicator = null;

class CommunicatorPlugin  {
    createCommunicator() {
        if (communicator !== null) return communicator;

        if (typeof window.NativeApp !== "undefined") { // Android
            communicator = new AppCommunicator("Android");
        } else if (typeof window.nativeAppCall === "function") { // iOS
            communicator = new AppCommunicator("iOS");
        } else if ( typeof window.webkit !== "undefined" &&
            typeof window.webkit.messageHandlers !== "undefined" &&
            typeof window.webkit.messageHandlers.nativeAppCall !== "undefined" &&
            typeof window.webkit.messageHandlers.nativeAppCall.postMessage === "function") {
            communicator = new AppCommunicator("webkit");
        } else {
            communicator = new BrowserCommunicator();
        }

        return communicator;
    }

    install(Vue) {
        Vue.prototype.$communicator = this.createCommunicator();
    }
}

export default new CommunicatorPlugin();